import { Switch as AriaSwitch, type SwitchProps as AriaSwitchProps } from "react-aria-components";
import { tv } from "tailwind-variants";
import { focusRing } from "../utils/focusRing";
import { composeTailwindRenderProps } from "../utils/utils";

const track = tv({
  extend: focusRing,
  base: "flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border border-transparent bg-muted shadow-sm transition-colors",
  variants: {
    isSelected: {
      true: "bg-purple-gradient",
    },
    isDisabled: {
      true: "cursor-default opacity-50",
    },
  },
});

const handle = tv({
  base: "pointer-events-none block h-3 w-3 rounded-full bg-background shadow-lg ring-0 transition-transform",
  variants: {
    isSelected: {
      true: "translate-x-3",
    },
  },
});

export interface SwitchProps extends Omit<AriaSwitchProps, "children"> {
  children?: React.ReactNode;
}

export function Switch({ children, ...props }: SwitchProps) {
  return (
    <AriaSwitch
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "group flex items-center gap-2 text-sm transition disabled:cursor-not-allowed"
      )}
    >
      {({ isSelected, isDisabled }) => (
        <>
          <div className={track({ isSelected, isDisabled })}>
            <span className={handle({ isSelected })} />
          </div>
          {children}
        </>
      )}
    </AriaSwitch>
  );
}
